<template>
 <div class="app-container">
   <el-tabs v-model="activeName" @tab-click="handleTabClick">
    <el-tab-pane label="中物系" name="0"> </el-tab-pane>
    <el-tab-pane label="兴瀚系" name="1"> </el-tab-pane>
  </el-tabs>
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="80px" size="mini" style="width: 100%;">
      <div class="formItemBox">
        <el-form-item label="子公司:">
           <el-select  v-model="searchForm.createSubcompanyCode" filterable placeholder="请选择" @change="fzgsChange">
              <el-option v-for="item in zigsList" :label="item.companyName" :value="item.companyCode" :key="item.id"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="部门名称:">
           <el-select  v-model="searchForm.createDepartmentCode" filterable placeholder="请选择" >
                <el-option v-for="item in FZbumenList" :label="item.name" :value="item.code" :key="item.id"></el-option>
              </el-select>
        </el-form-item>
        <el-form-item label="年月:">
           <el-select  v-model="searchForm.cycleMasterId" filterable placeholder="请选择" >
                <el-option v-for="item in yueList" :label="item.yearMonthDate" :value="item.id" :key="item.id"></el-option>
              </el-select>
        </el-form-item>
      </div>
       <div class="searchBtnBox" style="margin: 0;">
         <el-form-item >
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item >
         <el-form-item >
           <el-button type="primary" @click="resetForm('searchForm')">重置</el-button>
         </el-form-item>
          <el-form-item v-if="btnFlg[2]">
           <el-button type="primary" @click="daochuFn" :disabled='isDisable'>导出</el-button>
          </el-form-item>
         <el-form-item v-if="btnFlg[1]">
           <el-button type="primary" @click="weihuFn">总额维护</el-button>
         </el-form-item>
         <el-form-item >
           <p class="margin0">财务调整收入合计:<span class="red">{{totalJson.value3bSum}}</span>万元</p>
          </el-form-item>
         <el-form-item >
           <p class="margin0">部门调整收入合计:<span class="red">{{totalJson.value3aSum}}</span>万元</p>
          </el-form-item>
         <el-form-item >
           <p class="margin0">计划收入合计:<span class="red">{{totalJson.value3Sum}}</span>万元</p>
          </el-form-item>
          <el-form-item >
           <p class="margin0">财务调整支出合计:<span class="red">{{totalJson.value4bSum}}</span>万元</p>
          </el-form-item>
           <el-form-item >
           <p class="margin0">部门调整支出合计:<span class="red">{{totalJson.value4aSum}}</span>万元</p>
          </el-form-item>
           <el-form-item >
           <p class="margin0">计划支出合计:<span class="red">{{totalJson.value4Sum}}</span>万元</p>
          </el-form-item>
           <el-form-item >
           <p class="margin0">实际收入合计:<span class="red">{{totalJson.value12Sum}}</span>万元</p>
          </el-form-item>
           <el-form-item >
           <p class="margin0">实际支出合计:<span class="red">{{totalJson.value13Sum}}</span>万元</p>
          </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
   <div class="table" :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" height="100%" style="width: 100%" center border :row-style="setRowStyle">
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="value1" width="180" label="分子公司"></el-table-column>
        <el-table-column prop="value2"  min-width="150" label="部门">
           <template slot-scope="scope">
              <div>
                <el-button type="text" size="mini" @click="bumenFn(scope.row)">{{ scope.row.value2 }}</el-button>
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="value3b" width="80" label="财务调整(万元)"></el-table-column>
         <el-table-column prop="value3a" width="80" label="部门调整(万元)"></el-table-column>
        <el-table-column prop="value3" width="80" label="计划合计(万元)">
          <!-- <el-table-column prop="value3" min-width="100" label="收入"></el-table-column>
          <el-table-column prop="value4" min-width="100" label="支出"></el-table-column>
          <el-table-column prop="value5" min-width="100" label="收支差异"></el-table-column> -->
        </el-table-column>
        <template v-for="item in tableHeadList">
          <el-table-column :key="item.id" :label="item.name" :prop="item.valueKey" min-width="100">
          </el-table-column>
        </template>
        <el-table-column prop="value6" min-width="110" label="发生现金(万元)"> </el-table-column>
        <el-table-column prop="value8" min-width="110" label="发生承兑(万元)"> </el-table-column>
        <el-table-column prop="value10" min-width="110" label="发生现汇(万元)"></el-table-column>
        <el-table-column prop="value12" min-width="110" label="实际收支(万元)"> </el-table-column>
        <el-table-column prop="value14" min-width="110" label="偏差金额(万元)"></el-table-column>
        <el-table-column prop="planStatus" width="90" label="偏差率(%)">
          <template slot-scope="scope">
             <span >{{ scope.row.value16 }}%</span>
            </template>
        </el-table-column>
     </el-table>
   </div>
   <!-- 分页 -->
   <!-- <div>
     <el-pagination background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNo"
      :page-sizes="[25,50,100]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
     </el-pagination>
   </div> -->
   <!-- 维护 -->
    <el-dialog  title="维护总额" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible.sync="addFlag" width="550px" center>
      <div>
        <el-form  :inline="true" :rules="rules"  ref="zongeForm" :model="zongeForm"  class="demo-form-inline jiaoyan"  label-width="130px"  size="mini"  >
          <el-form-item label="公司系别:"  class="width1">
            {{ zongeForm.gongsixibie }}
          </el-form-item>
          <br>
          <el-form-item label="月份:"  class="width1">
            {{ zongeForm.businessTable }}
          </el-form-item>
           <br>
          <el-form-item label="可用现汇总额:" prop="kyxhAmount" class="jiage" >
            <el-input  placeholder=""  v-number-input.float="4"  maxlength="8" v-model="zongeForm.kyxhAmount"  ></el-input>
            <span class="danwei" >万元</span>
          </el-form-item>
           <br>
          <el-form-item label="可用承兑总额:" prop="kycdAmount" class="jiage" >
            <el-input  placeholder=""  v-number-input.float="4"  maxlength="8" v-model="zongeForm.kycdAmount"  ></el-input>
            <span class="danwei" >万元</span>
          </el-form-item>
           <br>
          <el-form-item label="不可立即变现资金:" prop="bkljbxAmount" class="jiage" >
            <el-input  placeholder=""  v-number-input.float="4"  maxlength="8" v-model="zongeForm.bkljbxAmount"  ></el-input>
            <span class="danwei" >万元</span>
          </el-form-item>
           <br>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFlag = false">取 消</el-button>
        <el-button type="primary" @click="saveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <monthDetail v-if="dialogDetail" :dialogDetail.sync="dialogDetail" :rowData="rowData" :title="xzTitle"></monthDetail>
 </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { findFundPlanCycleForToday, monthlyFundPlanReportForInOut, masterList, getAmountList, saveFundPlanCycleAmount, updateFundPlanCycleAmount } from '@/api/common-signature'
import { getCurrUserDepartment, getCurrUserCompany } from '@/api/newCrm'
import { dateFormat1, dateTimeFormat, emptyFn, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import monthDetail from '@/views/common-signature/fundingPlan/public/monthDetail.vue'
export default {
  components: { monthDetail },
  data () {
    return {
      activeName: '0',
      toFixed: toFixed,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      searchForm: {
        pageNo: 1,
        pageSize: 50
      },
      loading: false,
      tableList: [],
      userCode: localStorage.getItem('userCode'),
      isDisable: false,
      zigsList: [],
      yueList: [],
      zhouList: [],
      FZbumenList: [],
      tableHeadList: [],
      totalJson: {},
      cycleMasterId: null,
      dialogDetail: false,
      xzTitle: '',
      rowData: {},
      zongeForm: {},
      addFlag: false,
      rules: {
        kyxhAmount: [
          { required: true, message: '请输入可用现汇总额', trigger: 'blur' }
        ],
        kycdAmount: [
          { required: true, message: '请输入可用承兑总额', trigger: 'blur' }
        ],
        bkljbxAmount: [
          { required: true, message: '请输入不可立即变现资金', trigger: 'blur' }
        ]
      },
      btnFlg: [],
      btnIdArr: ['00FM0U0100', '00FM0U0200', '00FM0U0300']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/monthPlanSummary')
    getCurrUserCompany().then(res => { this.zigsList = res })
  },
  mounted () {
    findFundPlanCycleForToday().then(res => {
      this.yueList = res.cycleMasterList
      this.$set(this.searchForm, 'cycleMasterId', res.cycleMasterId)
      this.$set(this.searchForm, 'tenantFaction', this.activeName == 1 ? 1 : 0)
      this.cycleMasterId = res.cycleMasterId
      this.getList()
    })
  },
  methods: {
    // 导出
    async daochuFn (row) {
      this.isDisable = true
      let form = { ...this.searchForm }
      await exportExcel(
        this.global.smpName + '/tReportDataView/exportMonthlyFundPlanReportList',
        form,
        this.searchForm.tenantFaction == 1 ? '兴瀚系' : '中物系' + '月资金计划汇总'
      )
      this.isDisable = false
    },
    weihuFn () {
      if (!this.searchForm.cycleMasterId) {
        this.$message.error('请先选择年月')
        return
      }
      let gongsixibie = this.searchForm.tenantFaction == 1 ? '兴瀚系' : '中物系'
      let jons = this.yueList.find(itme => itme.id == this.searchForm.cycleMasterId)
      console.log(jons)
      let businessTable = jons.yearMonthDate
      getAmountList({ businessType: 0,
        businessTableId: this.searchForm.cycleMasterId,
        tenantFaction: this.searchForm.tenantFaction }).then(res => {
        if (res) {
          this.zongeForm = res
          this.zongeForm.gongsixibie = gongsixibie
          this.zongeForm.businessTable = businessTable
        } else {
          this.zongeForm = {
            gongsixibie: gongsixibie,
            businessTable: businessTable,
            tenantFaction: this.searchForm.tenantFaction,
            businessType: 0,
            businessTableId: this.searchForm.cycleMasterId,
            kyxhAmount: 0,
            kycdAmount: 0,
            bkljbxAmount: 0

          }
        }
        this.addFlag = true
      })
    },
    saveFn () {
      this.$refs.zongeForm.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.zongeForm.id) {
            updateFundPlanCycleAmount(this.zongeForm).then(res => {
              loading.close()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.addFlag = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            saveFundPlanCycleAmount(this.zongeForm).then(res => {
              loading.close()
              this.$message({
                message: '操作成功',
                type: 'success'
              })
              this.addFlag = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    closeDialog () {

    },
    setRowStyle ({ row, index }) {
      if (row.sumFlag === '1') {
        return {
          'font-weight': ' bold ', 'background-color': '#ccc'
        }
      }
      if (!row.sumFlag) {
        return {
          'font-weight': ' bold ', 'background-color': 'rgb(205 231 191)'
        }
      }
      return {}
    },
    handleTabClick () {
      this.$set(this.searchForm, 'tenantFaction', this.activeName == 1 ? 1 : 0)
      this.getList()
    },
    bumenFn (row) {
      masterList({
        pageNo: 1,
        pageSize: 50,
        cycleMasterId: this.searchForm.cycleMasterId,
        createDepartmentCode: row.createDepartmentCode
      }).then(res => {
        if (res.list.length > 0) {
          this.dialogDetail = true
          this.xzTitle = row.value2 + '-月计划详情'
          this.rowData = res.list[0]
          this.rowData.incomeExpenseType = row.incomeExpenseType
        } else {
          this.$message.error('暂无数据')
        }
      })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
            }
          })
        })
      // this.$router.push({ path: '/monthlyFundsPlan', query: { cycleMasterId: this.cycleMasterId, createDepartmentCode: row.createDepartmentCode } })
    },
    // 选择分子公司
    fzgsChange (e) {
      getCurrUserDepartment({ compayCode: e }).then(res => { this.FZbumenList = res })
      this.$set(this.searchForm, 'createDepartmentCode', null)
    },
    // 查选
    searchFn () {
      this.getList()
    },
    // 获取列表
    getList () {
      if (!this.searchForm.cycleMasterId) {
        this.$message.error('请先选择年月')
        return
      }
      this.loading = true
      getAmountList({ businessType: 0,
        businessTableId: this.searchForm.cycleMasterId,
        tenantFaction: this.searchForm.tenantFaction }).then(res => {
        this.$set(this.searchForm, 'kyxhAmount', res ? res.kyxhAmount : 0)
        this.$set(this.searchForm, 'kycdAmount', res ? res.kycdAmount : 0)
        this.$set(this.searchForm, 'bkljbxAmount', res ? res.bkljbxAmount : 0)
        monthlyFundPlanReportForInOut(this.searchForm).then(res => {
          this.tableList = res.headList.concat(res.dataList.reverse())
          this.tableHeadList = res.titleList
          this.totalJson = res.sumMap
          this.loading = false
          this.$nextTick(() => {
            let h = this.$refs.searchBox.offsetHeight
            let pH = document.documentElement.clientHeight
            this.h = (pH - h - 188) + 'px'
          })
        })
      })
    },
    // 重置
    resetForm (formName) {
      this.cycleMasterId = this.searchForm.cycleMasterId
      // debugger
      this.searchForm = {

      }
      this.$set(this.searchForm, 'cycleMasterId', this.cycleMasterId)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.getList()
    }

  }
}
</script>

<style scoped lang='less'>
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
